import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import ViewBrandContainer from 'containers/forms/brands/ViewBrandContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { AdminBreadcrumb, AdminBreadcrumbItem } from 'components/atoms/AdminBreadcrumb';
import PageTitle from 'hoc/PageTitle';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { ADMINAREA_ACCESS } from 'constants/capabilities';

const ViewBrandsPage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer
            title={(
                <AdminBreadcrumb>
                    <AdminBreadcrumbItem to="/admin/brands">&lt; brands</AdminBreadcrumbItem>
                </AdminBreadcrumb>)}
            admin hideDatePicker />}>

        <ViewBrandContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'View Brand', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS] }),
)(ViewBrandsPage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/brands/ViewBrand.js